import { h, Component } from "preact";
import { msg, t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import MobilePage from "../../utils/mobile-page";
import Page from "../../../../services/page-data-feed";
import Session from "../../utils/session";

import { CloseIconSlim } from "../../mobile-templates/general";
import VisibleOnHash from "../../utils/hash-popup";
import { TelegramButton } from "../../../../services/telegram/openidLogin";
import Config from "../../config";

export default class PopupLogin extends Component {
	state = {
		error: false,
		errorMessage: ""
	};
	form = null;

	login() {
		const loginForm = new FormData(this.form);
		Session.loginPromise(loginForm.get('username'), loginForm.get('password')).then(resp => {
			this.setState({ error: false, errorMessage: "" });
			MobilePage.closeHashPopup();
			Page.rerender();
		}).catch(err => {
			this.setState({ error: true, errorMessage: err });
		}); // Se devi aggiungere altro fai questa funzione in async
	}

	render() {
		return (
			<VisibleOnHash id="login-page" class={"fixed z-10 inset-0 overflow-y-auto text-white backdrop-blur-sm"} hash="#login">
				<div class="absolute top-0 right-0 w-12 p-3 fn-close" onClick={e => MobilePage.closeHashPopup()}>
					<CloseIconSlim />
				</div>
				<div class="pl-12 h-full">
					<div class="flex h-full flex-col bg-blue-whale-800 text-white">
						<form class="fn-login-form" ref={ref => this.form = ref} onSubmit={e => { e.preventDefault(); this.login() }}>
							<div class="px-4 pb-1 pt-3 text-lg"><Trans>Login</Trans></div>
							<div class="p-2">
								<div class="mob-panel-row p-2">
									<div class="text-sm"><Trans>Login</Trans></div>
									<div class="pt-1 relative">
										<div class="absolute text-xs top-0 bottom-0 flex items-center pl-1 pt-1 bg-transparent text-slate-950">+251 (0)</div>
										<input
											class="w-full rounded-sm bg-white px-2 py-1 text-black disabled:bg-blue-whale-600 disabled:text-white pl-12"
											name="username"
											autocomplete="username"
										/>
									</div>
								</div>
								<div class="mob-panel-row p-2">
									<div class="text-sm"><Trans>Password</Trans></div>
									<div class="pt-1">
										<input
											class="w-full rounded-sm bg-white px-2 py-1 text-black disabled:bg-blue-whale-600 disabled:text-white"
											type="password"
											name="password"
											autocomplete="current-password"
										/>
									</div>
								</div>
								<div class="mob-panel-row p-2 hidden">
									<div class="text-sm">
										<input type="checkbox" class="mr-1" />
										<Trans>Remember Password</Trans>
									</div>
								</div>
							</div>
							{this.state.error && <div class="fn-error-message">
								<div class="w-full px-2 text-center pt-3 mb-2">
									<div class="bg-gray-200 border py-2 relative rounded text-base text-center text-red-600 w-full">
										<div class="-top-1/3 absolute bg-red-500 border border-red-600 flex font-bold h-8 items-center justify-center left-2 rounded-full text-white text-xl w-8">!</div>
										<span>{window.Translation(this.state.errorMessage)}</span>
										{/*<span><Trans>For security reasons, please click on "Forgot your password"</Trans></span>*/}
									</div>
								</div>
							</div>}
							<div class="p-2 px-4">
								<button class="w-full rounded bg-kobaaccent-500 py-2 text-center text-lg text-black"><Trans>Login</Trans></button>
								<a class="block mt-6 px-3 text-center text-sm" href="#recovery"><Trans>Forgot your password?</Trans></a>
							</div>
						</form>

						{!!Config.telegramLogin && <>
							<div class="relative flex justify-center px-4 pt-8 pb-2 text-center">
								<div class="absolute bottom-4 left-4 right-4 border-b"></div>
								<div class="z-0 bg-blue-whale-800 px-4 text-sm"><Trans>Oppure</Trans></div>
							</div>
							<div class="px-4">
								<TelegramButton
									class="w-full"
									clientId={Config.telegramLogin}
									text={t`Login via Telegram`}
									shape="square"
									iconOnly={false}
									onSuccess={e => {
										MobilePage.closeHashPopup();
										Page.rerender();
									}}
								/>
							</div>
						</>}

						<div class="pt-6 text-center hidden">Facebook &amp; Google</div>
						<div class="grow"></div>
						<div class="bg-blue-whale-700 px-2 py-2">
							<div class="py-1 text-center">
								<Trans>Create an account</Trans>
								<a class="border-b border-kobaaccent-500 pb-0.5 px-0.5 text-kobaaccent-500" href="#register">
									<Trans>Register</Trans>
								</a>
							</div>
							<div class="py-1 text-center text-sm"><Trans>Login to place bets</Trans></div>
						</div>
					</div>
				</div>
			</VisibleOnHash>
		);
	}
}
